<template>
  <div>
    <el-dropdown trigger="click" @command="handleSetSize">
      <div class="size-icon--style">
        <svg-icon class-name="size-icon" icon-class="language" style="width: 22px; height: 22px;" />
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item v-for="item of langOptions" :key="item.value" :disabled="lang === item.value"
            :command="item.value">
            {{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script setup>
import { $t } from "@/plugins/i18n";
import useAppStore from "@/store/modules/app";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const appStore = useAppStore();
const lang = computed(() => appStore.lang);
const route = useRoute();
const router = useRouter();
const { proxy } = getCurrentInstance();
const langOptions = ref([
  { label: "中文", value: "zh" },
  { label: "English", value: "en" },
  { label: "Română", value: "ro" },
  { label: "Italiano", value: "it" },
  { label: "Español", value: "es" },
  { label: "Deutsch", value: "de" },
  { label: "Nederlands", value: "nl" },
  { label: "Français", value: "fr" },
  { label: "Magyar", value: "hu" },
]);

function handleSetSize(size) {
  proxy.$modal.loading(t("tips.switchLanguage"));
  appStore.setLang(size);
  setTimeout("window.location.reload()", 1000);
}
</script>

<style lang='scss' scoped>
.size-icon--style {
  width: 20px;
  height: 20px;
  vertical-align: 10px;
}
</style>